import _partners from "./summary";
import AppId from "~/utils/partner";

export const partnerInfo = _partners[AppId];

export const medproInfo = _partners.medpro;
